export const CrmObjectTypes = Object.freeze({
  CONTACT: 'contact',
  COMPANY: 'company',
  DEAL: 'deal',
  TICKET: 'ticket',
  PRODUCT: 'product',
  QUOTE: 'quote',
  MARKETING_EVENT: 'marketing_event'
});